import classNames from 'classnames';
import { useStaticQuery, graphql, navigate } from 'gatsby';
import React from 'react';
import AnimateReveal from '../AnimateReveal/AnimateReveal';
import Button, { themes as buttonThemes, sizes } from '../UI/Button/Button';
import Emphasise from '../UI/Emphasise/Emphasise';
import Form, { themes as fieldThemes } from '../UI/Form/Form';
import PostcodeSearch from '../UI/PostcodeSearch/PostcodeSearch';
import Ripple from '../UI/Ripple/Ripple';
import Section, { themes } from '../UI/Section/Section';
import { motion } from '../UI/framer-motion-custom';
import * as styles from './LocationsBanner.module.scss';

const LOCATIONS_QUERY = graphql`
  query LocationsBannerQuery {
    wp {
      acfOptionsCommonBlocks {
        common {
          locationFinder {
            heading
            description
          }
          serviceFinder {
            heading
            description
          }
        }
      }
    }

    serviceCategories: allWpServiceCategory {
      nodes {
        label: name
        children: services {
          nodes {
            label: title
            value: id
          }
        }
      }
    }
  }
`;

const LocationsBanner = ({ filterByService = false, defaultService, ...other }) => {
  const {
    wp: {
      acfOptionsCommonBlocks: {
        common: { locationFinder, serviceFinder },
      },
    },
    serviceCategories,
  } = useStaticQuery(LOCATIONS_QUERY);
  const fieldTheme = filterByService ? fieldThemes.PRIMARY : fieldThemes.SECONDARY;
  const classname = classNames(styles.locationFinder, {
    [ styles.serviceFinder ]: filterByService,
  });

  function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const serialised = new URLSearchParams(formData).toString();
    navigate(`/locations/?${serialised}`);
  }

  return (
    <Section {...other} theme={themes.DEFAULT} id="locations">
      <AnimateReveal className={classname} staggerChildren={true}>
        <motion.div className={styles.body}>
          <Emphasise tag="h2" className={styles.heading}>
            {!filterByService ? locationFinder.heading : serviceFinder.heading}
          </Emphasise>
          <p>
            {!filterByService
              ? locationFinder.description
              : serviceFinder.description}
          </p>
        </motion.div>

        <Form
          as={motion.form}
          className={styles.form}
          action="/locations/"
          onSubmit={handleSubmit}
        >
          {filterByService && (
            <Form.Row>
              <Form.Select
                label="Select your service"
                name="service"
                id="service"
                theme={fieldTheme}
                options={serviceCategories.nodes}
                value={defaultService}
                isReverse
                required
              />
            </Form.Row>
          )}

          <Form.Row>
            <PostcodeSearch theme={fieldTheme} isReverse required />
          </Form.Row>

          <Button
            type="submit"
            theme={buttonThemes.PRIMARY}
            isReverse
            isBlock
            size={sizes.LARGE}
          >
            {!filterByService ? `Find locations` : `Find service`}
          </Button>
        </Form>

        <Ripple className={styles.ripple} />
      </AnimateReveal>
    </Section>
  );
};

export default LocationsBanner;
